/**
 * Created by jiafengf.wang on 2020/5/25.
 * 通用API--请求发送
 */
import fc from '@qnpm/react-native-ext-fetch-web';
var tasks = {};
var id = 1;

var createRequestId = function createRequestId() {
  return "request-".concat(id++);
};

export var abortRequest = function abortRequest(id) {
  if (id && tasks[id]) {
    tasks[id].abort();
  }
};

var request = function request() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var promise = fc(options);
  return {
    promise: promise,
    requestId: createRequestId()
  };
};

export default request;